


























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { SignersTabModel, DynamicFormModel, WorkflowJobModel } from '@/types';
import WorkflowDynamicForm from '@/components/workflow/WorkflowDynamicForm.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { DocuSignWorkflowJob, ObjectHelper, TabsHelper } from '@/mixins';

export default Vue.extend({
  name: 'DocuSignSignersTab',
  mixins: [DocuSignWorkflowJob, ObjectHelper, TabsHelper],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('docuSignWorkflowJobStore', ['getSignersTab']),
    getSignersTabData(this: any) {
      this.getSignersTab(this.workflowJob.jobId);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['workflowDataSourceField', 'workflowJob']),
    ...mapGetters('docuSignWorkflowJobStore', ['signersTab', 'isSignersTabLoading'])
  },
  watch: {
    isSignersTabLoading(this: any, value: boolean) {
      if (!value) {
        this.handleTabsLoaded();
      }
    }
  },
  mounted() {
    this.getSignersTabData();
  },
  components: {
    WorkflowDynamicForm,
    LoadingSpinner
  }
});
